<template>
<div id="trafico-detalle-facturas">

    <v-dialog v-model="modal" max-width="40%" style=" z-index: 400 !important;">
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal">
                    <i class="fa fa-file-archive-o" aria-hidden="true"></i>&nbsp;
                    <span class="subheading">
                        <strong>Cargar Archivo ZIP/XML</strong>
                    </span>
                </v-card>
                <v-spacer></v-spacer>
                <br /><br />
                <v-btn icon @click.native="modal = false; reset()" class="close_modal">
                    <v-icon class="white--text">cancel</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <input type="file" accept="application/xml, application/zip" id="file" ref="file" v-on:change="handleFileUpload()" />
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal = false; reset()">
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" :loading="loading" :disabled="!showfile" @click.native="submitFile()">
                    <v-icon>done</v-icon>Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modalFactura" max-width="40%" style=" z-index: 400 !important;">
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal">
                    <i class="fa fa-file-o" aria-hidden="true"></i>&nbsp;
                    <span class="subheading">
                        <strong>Adjuntar Documento a Factura: {{modalFacturaNumero}}</strong>
                    </span>
                </v-card>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="modalFactura = false; modalFacturaNumero=''; reset()" class="close_modal">
                    <v-icon class="white--text">cancel</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-chip outlined v-if="verificaArchivo(modalFacturaArchivo)" color="info" text-color="indigo">
                    <v-avatar>
                        <v-icon color="indigo">info</v-icon>
                    </v-avatar>
                    <strong>{{verificaArchivo(modalFacturaArchivo) ? "Ya se adjuntó un documento a esta factura. Si adjunta otro, se reemplazará el existente." : ''}}</strong>
                    </v-chip>

                    <br v-if="verificaArchivo(modalFacturaArchivo)" />
                    <br v-if="verificaArchivo(modalFacturaArchivo)" />

                    <v-container>
                        <input type="file" accept="application/pdf" id="fileFactura" ref="fileFactura" v-on:change="handleFileUploadFactura()" />
                    </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click.native="modalFactura = false; modalFacturaNumero=''; reset()">
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn small color="error" :loading="loadingDelete" v-show="verificaArchivo(modalFacturaArchivo)" @click.native="deleteFileFactura(modalFacturaArchivo, modalFacturaSecuencia)">
                    <v-icon>delete_forever</v-icon>Eliminar
                </v-btn>
                <v-btn small color="info" :loading="loadingDownload" v-show="verificaArchivo(modalFacturaArchivo)" @click.native="downloadFileFactura(modalFacturaArchivo)">
                    <v-icon>arrow_downward</v-icon>Descargar
                </v-btn>
                <v-btn small color="success" :loading="loading" :disabled="!showfile" @click.native="submitFileFactura(modalFacturaRfc, modalFacturaSecuencia)">
                    <v-icon>arrow_upward</v-icon>Adjuntar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modalUpload" max-width="40%" style=" z-index: 400 !important;">
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal">
                    <v-icon class="white--text">arrow_upward</v-icon>&nbsp;
                    <span class="subheading">
                        <strong>Cargar Plantilla Excel</strong>
                    </span>
                </v-card>
                <v-spacer></v-spacer>
                <br /><br />
                <v-btn icon @click.native="modalUpload = false" class="close_modal">
                    <v-icon class="white--text">cancel</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <exportar-excel :data="camposLayout" :exportFields="encabezadoLayout" name="Layout Facturas.xlsx">
                        <v-btn fab small dark class="close_modal" color="purple darken-2" title="Descargar Plantilla" v-tippy>
                            <v-icon dark>receipt</v-icon>
                        </v-btn>
                    </exportar-excel>
                    <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" :smallIcon=true title="Cargar Plantilla" icon="cloud_upload" :showIcon=false />

                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modalUpload = false">
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-btn ref="scrollBtnInc" v-show="false" @click="$vuetify.goTo((ultimoDetalle),{duration: 1500,offset: 100})"> Scroll
    </v-btn>
    <v-form ref="form" id="detalle_facturas_form">

        <div class="row">
            <div class="col-xs-1">
                <v-btn fab dark x-small color="green" v-on:click="addNew(); $vuetify.goTo('#sumarizeDivInc',{duration: 2000,offset: 100})" title="Agregar" v-tippy>
                    <v-icon dark>add</v-icon>
                </v-btn>
            </div>
            <div class="col-xs-1">
                <v-btn fab x-small dark color="orange darken-1" title="Cargar ZIP/XML" v-tippy @click="modal=true">
                    <v-icon dark>folder_open</v-icon>

                </v-btn>
            </div>
            <div class="col-xs-1">
                <v-btn fab x-small dark color="blue darken-1" title="Cargar Plantilla" v-tippy @click="modalUpload=true">
                    <v-icon dark>cloud_upload</v-icon>
                </v-btn>
            </div>

            <div class="col-xs-8">

            </div>
        </div>
        <div class="row">

            <div class="col-xs-10"></div>
        </div>
        <div v-for="(detalle, index) in detalles" v-bind:key="index" @keyup.enter="nextTab">
            <v-row style="flex-wrap: nowrap;">
                <v-col cols="2" class="flex-grow-0 flex-shrink-0">
                    <v-autocomplete v-model="detalle.emisor" :items="emisores" :hide-no-data="true" item-text="metadato" item-value="metadato" label="Selecciona un Emisor/Destinatario" :rules="[rules.required]" @input="setEmisor(detalle.emisor, index)"></v-autocomplete>

                </v-col>
                <v-col cols="2" class="flex-grow-1 flex-shrink-0">
                    <v-text-field label="Tax ID" type="text" autocomplete="off" v-model="detalle.tax_id" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="2" class="flex-grow-0 flex-shrink-1">
                    <v-text-field label="Número Factura" type="text" autocomplete="off" v-model="detalle.numero" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="2" class="flex-grow-0 flex-shrink-1">
                    <v-text-field label="Número Secuencia de Factura" type="text" autocomplete="off" v-model="detalle.secuencia" :rules="[rules.required,verificaSecuenciaError(detalle.numero, detalle.tax_id, detalle.secuencia)]"></v-text-field>
                </v-col>
                <v-col cols="2" class="flex-grow-0 flex-shrink-1">
                    

                    <v-menu offset-x :ref="'mf'+detalle.index" :close-on-content-click="false"  v-model="detalle.menu" :nudge-right="40"  transition="scale-transition" offset-y max-width="290px" min-width="290px">                        
                        <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" label="Fecha Expedición" type="text" prepend-icon="event" mask="####-##-##" :value="parseDatePicker(detalle.fecha)" :rules="[rules.required]"></v-text-field>
                        </template>
                        <v-date-picker v-model="detalle.fecha" no-title @input="detalle.menu = false; detalle.fecha = parseDate(detalle.fecha); " locale="es-mx"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="2" class="flex-grow-0 flex-shrink-1">
                    <v-text-field label="Total USD" type="text" autocomplete="off" :readonly="detalle.conceptos!=undefined && detalle.conceptos.length>0" v-model="detalle.importe" :rules="[rules.number, rules.required]"></v-text-field>

                </v-col>
                <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                    <v-speed-dial :id="index" direction="left" open-on-hover>
                        <template v-slot:activator>
                            <v-btn :id="index" x-small fab dark color="primary">
                                <v-icon>reorder</v-icon>
                            </v-btn>
                        </template>
                        <v-btn fab dark x-small color="blue-grey darken-1" v-if="(detalle.archivo=='' || verificaArchivo(detalle.archivo))" @click="addFileFactura(detalle.numero, detalle.tax_id, detalle.archivo, detalle.secuencia)" title="Agregar Documento" v-tippy>
                            <v-icon dark>attach_file</v-icon>
                        </v-btn>
                        <v-btn fab dark x-small color="blue-grey darken-3" @click="addDetail(index)" title="Agregar Detalle" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>
                        <v-btn fab dark x-small color="red" @click="remove(index)" title="Eliminar Factura" v-tippy>
                            <v-icon dark>remove</v-icon>
                        </v-btn>
                    </v-speed-dial>
                </v-col>
            </v-row>
            <!-- DETALLE -->
            <div id="detalle_conceptos">
                <div v-for="(detalleConcepto, indexConcepto) in detalle['conceptos']" v-bind:key="indexConcepto">
                    <hr id="separaConcepto" v-show="indexConcepto != 0">

                    <v-row style="flex-wrap: nowrap;" v-bind:id="'newConcepto'+index+'_'+indexConcepto">
                        <v-col cols="4" class="flex-grow-0 flex-shrink-0">
                            <v-autocomplete v-model="detalleConcepto.concepto" :items="conceptos" :hide-no-data="true" item-text="concepto" item-value="concepto" label="Concepto" :rules="[rules.required]"></v-autocomplete>

                        </v-col>
                        <v-col cols="3" class="flex-grow-1 flex-shrink-0">
                            <v-text-field label="Descripción del Incrementable" type="text" autocomplete="off" v-model="detalleConcepto.descripcion" maxlength="250" :rules="[rules.required]"></v-text-field>

                        </v-col>
                        <v-col cols="3" class="flex-grow-0 flex-shrink-1">
                            <v-text-field label="Valor en Dólares" type="text" autocomplete="off" v-model="detalleConcepto.valor_dolares" :rules="[rules.number, rules.required]"></v-text-field>

                        </v-col>
                        <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                            <v-btn fab dark x-small color="red" @click="removeDetail(index, indexConcepto)" title="Eliminar Concepto" v-tippy>
                                <v-icon dark>remove</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>

                </div>
            </div> <!-- Detalle Conceptos-->

            <hr id="separaFactura">
        </div>
        <p id="sumarizeDivInc" class="text-right"><span v-if="total_usd>0" style="font-size:14pt">TOTAL USD: {{total_usd | moneda}}</span></p>
    </v-form>

    <p />
    <p />
    <p />

    <!-- Pdf -->
    <div style="display: none;">
        <v-pdf-component ref="pdf" :modelPdf="modelPdf" />
    </div>

</div>
</template>

<script>
import axios from 'axios';
import Vue from "vue";
import moment, {
    invalid
} from "moment";
import html2pdf from "html2pdf.js";
import pdf from "@/components/trafico/Pdf.vue";
import {
    filter
} from 'minimatch';

export default {
    components: {
        "v-pdf-component": pdf,
    },

    data: () => ({
        fab: false,
        detalles: [],
        modelPdf: {
            tipo_operacion: "",
            responsable_trafico: "",
            nombre_trafico: "",
            referencia: "",
            fecha_embarque: "",
            fecha_llegada: "",
            agente_aduanal: "",

            aduana_despacho: "",
            agente_carga: "",
            referencia_hbl: "",
            booking: "",
            puerto_embarque: "",
            modalidad_transporte: "",
            tipo_embarque: "",
            transportista_master: "",
            referencia_master: "",
            recinto_fiscal: "",

            detalles_carga: [],
            embarques: [],
            transportes: [],
            alertas: [],
            facturas: [],

            movimientos: []
        },
        total_usd: 0, //Sumatoria del importe de las facturas     
        emisores: [],
        conceptos: [{
            concepto: "Seguros"
        }, {
            concepto: "Fletes"
        }, {
            concepto: "Embalajes"
        }, {
            concepto: "Otros"
        }],
        formUpdated: false,
        file: '',
        fileName: '',
        fileFactura: '',
        sizeFactura: 0,
        fileFacturaName: '',
        filetext: '',
        showfile: false,
        URL: '',
        modal: false,
        modalFactura: false,
        modalFacturaArchivo: '',
        modalFacturaNumero: '',
        modalFacturaRfc: '',
        modalFacturaSecuencia: '',
        modalUpload: false,
        show_loading: false,
        loading: false,
        loadingDelete: false,
        loadingDownload: false,

        rules: {
            required: v => !!v || "Este campo es requerido",
            number: value => {
                const pattern = /^[\d]*\.?[\d]*$/;
                return pattern.test(value) || "Campo numérico";
            },
            entero: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Número entero";
            }
        },
        encabezadoLayout: {
            //Factura
            tax_id: "tax_id",
            fecha: "fecha",
            numero: "numero",
            secuencia: "secuencia",
            //Conceptos
            concepto: 'concepto',
            descripcion: 'descripcion',
            valor_dolares: 'valor_dolares',
        },
        camposLayout: [{
            //factura
            tax_id: "[RFC o Tax ID del emisor]",
            fecha: "[Fecha de Expedición en formato AAAA-MM-DD]",
            numero: "[Número de Factura]",
            secuencia: "[Número de Partida secuencia de Factura]",
            //Conceptos
            concepto: '[Seguros | Fletes | Maniobras | Otros]',
            descripcion: '[Descripción del incrementable]',
            valor_dolares: '[Valor en Dólares]',
        }],
        camposObligatorios: [
            //factura
            "tax_id",
            "fecha",
            "numero",
            "secuencia",
            //Conceptos
            "concepto",
            "descripcion",
            "valor_dolares",
        ],
        ultimoDetalle: '',
    }),

    methods: {
        nextTab() {
            this.$emit('nextTab', 7);
        },
        addNew: function () {
            this.detalles.push(Vue.util.extend({}, {
                //Se debe incluir para poder meter los conceptos, los demas campos no importan, este si porque es un arreglo dentro de otro
                conceptos: [],
            }));
        },
        addDetail: function (index) {
            var detalle = this.detalles[index]
            if (detalle['conceptos'] == undefined)
                detalle['conceptos'] = [];
            detalle['conceptos'].push(Vue.util.extend({}, {}));

            //Scroll al elemento agregado
            var contMercancias = detalle['conceptos'].length - 2; //le restamos 2 para asegurar que el elemento DOM exista
            if (contMercancias >= 1) {
                this.ultimoDetalle = "#newConcepto" + index + "_" + contMercancias;
                const elem = this.$refs.scrollBtnInc;
                elem.click(new Event("click"));
            }
        },
        remove: function (index) {
            var detalle = this.detalles[index];
            if (this.verificaArchivo(detalle.archivo)) {
                this.$swal({
                    type: "info",
                    title: "Cuidado!",
                    text: 'La factura tiene un archivo adjunto, si desea eliminar la factura primero debe eliminar el archivo.'
                });
            } else
                Vue.delete(this.detalles, index);
        },
        removeDetail: function (index, indexConcepto) {
            var detalle = this.detalles[index]
            Vue.delete(detalle['conceptos'], indexConcepto);
        },
        setEmisor: function (emisor, indice) {
            var emisores = this.emisores.filter(function (emi) {
                return emi.metadato == emisor;
            });
            this.detalles[indice]['tax_id'] = emisores[0].rfc;
        },
        parseDate(date) {
            //Formato  YYYY-MM-DDThh:mm
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD[T]HH:mm:SS");
        },
        parseDatePicker(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateExcel(excelDate) {
            try {
                if (!excelDate) return false;
                var fecha = '';
                if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
                    fecha = moment(String(excelDate)).format("YYYY-MM-DD");
                else
                    fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
                if (fecha == 'Invalid date') return false;
                return fecha;
            } catch (error) {
                return false;
            }
        },

        guardar: function (resolve) {
            var referencia = this.$local_storage.get('referencia');
            var rfc = this.$local_storage.get('rfc');
            if (referencia != null && referencia.trim() != '') {
                const datos = {
                    rfc: rfc,
                    referencia: referencia,
                    incrementables: this.detalles,
                };
                //console.log(datos);

                if (!this.$refs.form.validate()) {
                    this.$swal({
                        type: "info",
                        title: "Cuidado!",
                        text: 'Datos incompletos en el formulario. Favor de verificar.'
                    });
                    resolve(false);
                } else if (this.formUpdated == true) { //Cuando se hicieron cambios en el formulario, hay que guardarlos
                    this.$root.$dialogLoader.show('Espere un momento por favor..');
                    axios({
                            method: "put",
                            url: this.URL + "actualizar/",
                            data: datos
                        })
                        .then((res) => {
                            this.$root.$dialogLoader.hide();
                            this.modal = false;
                            this.formUpdated = false;
                            this.cargar();
                            if (this.detalles.length > 0) {
                                this.$swal({
                                    type: "success",
                                    title: "Operación Exitosa!!",
                                    text: "El Detalle de Incrementables se guardó correctamente. ¿Desea adjuntar documento digitalizado a las facturas antes de continuar?",
                                    footer: "",
                                    showCancelButton: true,
                                    cancelButtonColor: "#d33",
                                    confirmButtonColor: "#3085d6",
                                    confirmButtonText: "Si",
                                    cancelButtonText: "No"
                                }).then(result => {
                                    if (result.value) {
                                        resolve(false);
                                    } else {
                                        if (this.$local_storage.get("update") != 'true') { //Solo cuando se guarda el tráfico la primera vez
                                            resolve(this.enviarCorreos());
                                        } else {
                                            this.showMensajeExito(referencia, "");
                                            resolve(true);
                                        }
                                    }
                                });
                            } else { //Si no se ingresaron incrementables, preguntamos lo de los correos
                                if (this.$local_storage.get("update") != 'true') { //Solo cuando se guarda el tráfico la primera vez
                                    resolve(this.enviarCorreos());
                                } else {
                                    this.showMensajeExito(referencia, "");
                                    resolve(true);
                                }
                            }
                        })
                        .catch((error) => {
                            this.$swal({
                                position: "center",
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: 'Error al guardar los datos!'
                                //showConfirmButton: false,
                            });
                            console.log(error);
                            this.$root.$dialogLoader.hide();
                            this.modal = false;
                            resolve(false);
                        });
                } else { //Cuando no se hizo ningún cambio en el formulario
                    if (this.$local_storage.get("update") != 'true') { //Solo cuando se guarda el tráfico la primera vez
                        resolve(this.enviarCorreos());
                    } else {
                        this.showMensajeExito(referencia, "");
                        resolve(true);
                    }

                }
            } else {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: 'Primero debe guardar datos generales del tráfico'
                });
                resolve(false);
            }
        },

        cargar: function () {
            var referencia = this.$local_storage.get('referencia');
            var rfc = this.$local_storage.get('rfc');
            if (referencia != null && referencia.trim() != '') {
                var datos = {
                    rfc: rfc,
                    referencia: referencia,
                };
                this.$root.$dialogLoader.show('Espere un momento por favor..');
                axios.post(this.URL + 'obtener/', datos)
                    .then((res) => {

                        if (typeof res.data !== 'undefined') {
                            this.detalles = res.data.incrementables;
                            var thisC = this;
                            this.detalles.forEach(function (el) {
                                el.archivo = thisC.verificaArchivo(el.archivo) ? el.archivo : '';
                            })
                        }
                    })
                    .catch((err) => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Error al obtener las facturas"
                            //showConfirmButton: false,
                        });
                        console.log(err);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.formUpdated = false;
                    });
            }

        },

        cargarEmisores: function () {
            var cliente_id = this.$local_storage.get("id_cliente");
            if (cliente_id > 0) {
                var datos = {
                    cliente: cliente_id,
                };
                axios.post(this.$hostname + 'catalogos/emisores_destinatarios/get_emisores/', datos)
                    .then((res) => {
                        if (typeof res.data !== 'undefined') {
                            this.emisores = res.data;
                        }
                    })
                    .catch((err) => {
                        console.log(err.response);
                    });
            }

        },
        verificaEmisor: function (emisorrfc, opcion) {
            var search = this.emisores.filter(function (e) {
                return e.rfc.trim().toLowerCase() == emisorrfc.toString().trim().toLowerCase();
            });
            if (search.length > 0) {
                if (opcion == 'verifica')
                    return true;
                else
                    return search[0].rfc;
            } else
                return false;
        },
        verificaConcepto: function (concepto, opcion) {
            var search = this.conceptos.filter(function (e) {
                return e.concepto.toString().trim().toLowerCase() == concepto.toString().trim().toLowerCase();
            });
            if (search.length > 0) {
                if (opcion == 'verifica')
                    return true;
                else
                    return search[0].concepto;
            } else
                return false;
        },
        verificaFactura: function (factura, emisorrfc) {
            if (this.detalles.length > 0) {
                var search = this.detalles.filter(function (e) {
                    if (e.numero != undefined && e.tax_id != undefined)
                        return e.numero.toString().trim().toLowerCase() == factura.toString().trim().toLowerCase() &&
                            e.tax_id.trim().toLowerCase() == emisorrfc.toString().trim().toLowerCase();
                });
                if (search.length > 0)
                    return true;
                else
                    return false;
            }
        },
        verificaSecuenciaError: function (factura, emisorrfc, secuencia) {
            if (factura != undefined && emisorrfc != undefined && secuencia != undefined) {
                var search = this.detalles.filter(function (e) {
                    if (e.numero != undefined && e.tax_id != undefined)
                        return e.numero.toString().trim().toLowerCase() == factura.toString().trim().toLowerCase() &&
                            e.tax_id.toString().trim().toLowerCase() == emisorrfc.toString().trim().toLowerCase() &&
                            e.secuencia.toString().trim().toLowerCase() == secuencia.toString().trim().toLowerCase();
                });
                if (search.length > 1) //Si encuentra 2 o mas (incluye el registro editado)
                    return 'El número de secuencia ya se ha registrado para la misma factura.';
                else
                    return true;
            } else
                return true;

        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
        containsKey(obj, key) {
            return Object.keys(obj).includes(key);
        },
        getObjFactura: function (results) {
            var objFactura = {
                emisor: '',
                tax_id: '',
                fecha: '',
                numero: '',
                secuencia: '',
                importe: 0,
                conceptos: [],
            };
            for (var k in objFactura) {
                if (this.containsKey(results, k))
                    objFactura[k] = results[k];
            }
            objFactura.conceptos.push(this.getObjConcepto(results));

            return objFactura;
        },
        getObjConcepto: function (results) {
            var objConcepto = {
                concepto: '',
                descripcion: '',
                valor_dolares: '',
            };
            for (var k in objConcepto) {
                if (this.containsKey(results, k))
                    objConcepto[k] = results[k];
            }
            return objConcepto;
        },
        verificaArchivo: function (archivo) {
            if (archivo == undefined)
                return false;
            else
                return archivo.toString().trim().length > 4;
        },

        beforeUpload(file) {
            const filesize = file.size;

            if (filesize < 1000 * 1000 * 5) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 5MB.",
                footer: ""
            });
            return false;
        },
        handleSuccess({
            results,
            header
        }) {
            /** PLANTILLA */
            this.cargarEmisores();
            var erroresCont = 0;
            var erroresText = '';
            var errorTmp = '';
            var detalle = false;
            var registrosExcel = [];
            for (var k in results) {
                detalle = false;
                var fechaOrig = results[k]["fecha"];
                results[k]["fecha"] = this.parseDateExcel(results[k]["fecha"]);
                var obligatorios = this.verificaObligatorios(results[k]);
                if (obligatorios !== true) {
                    erroresCont++;
                    if (erroresText.indexOf(obligatorios) == -1)
                        erroresText += obligatorios;
                } else if (results[k]["fecha"] == false) {
                    erroresCont++;
                    errorTmp = '<br/>' + "- La fecha '" + fechaOrig + "' no es una fecha válida.";
                    if (erroresText.indexOf(errorTmp) == -1)
                        erroresText += errorTmp;
                } else if (!this.verificaEmisor(results[k]["tax_id"], 'verifica')) {
                    erroresCont++;
                    errorTmp = '<br/>' + "- El Tax ID:'" + results[k]["tax_id"] + "' no existe en el catálogo de emisores/destinatarios";
                    if (erroresText.indexOf(errorTmp) == -1)
                        erroresText += errorTmp;
                } else if (!this.verificaConcepto(results[k]["concepto"], 'verifica')) {
                    erroresCont++;
                    errorTmp = '<br/>' + "- El concepto:'" + results[k]["concepto"] + "' no es un concepto válido";
                    if (erroresText.indexOf(errorTmp) == -1)
                        erroresText += errorTmp;
                } else {
                    results[k]["tax_id"] = this.verificaEmisor(results[k]["tax_id"], 'obtener')
                    results[k]["concepto"] = this.verificaConcepto(results[k]["concepto"], 'obtener');
                    results[k]["fecha"] = this.parseDate(results[k]["fecha"]);
                    var emisores = this.emisores.filter(function (emi) {
                        return emi.rfc == results[k]["tax_id"];
                    });
                    results[k]["emisor"] = emisores[0].metadato;

                    for (var key in this.detalles) { //Si ya existe la factura solo se agrega el Concepto
                        if (this.detalles[key].tax_id.toString().trim().toLowerCase() == results[k]["tax_id"].toString().trim().toLowerCase() &&
                            this.detalles[key].numero.toString().trim().toLowerCase() == results[k]["numero"].toString().trim().toLowerCase() &&
                            this.detalles[key].secuencia.toString().trim().toLowerCase() == results[k]["secuencia"].toString().trim().toLowerCase()
                        ) {
                            detalle = true;
                            this.detalles[key]['conceptos'].push(this.getObjConcepto(results[k]));
                        }
                    }
                    if (detalle == false) { //Si es cabecera, se agrega factura y concepto
                        this.detalles.push(this.getObjFactura(results[k]));
                    }

                    registrosExcel.push(results[k]);
                }
            }

            if (erroresCont > 0) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                    footer: erroresText,
                });
            } else if (registrosExcel.length == 0) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "El archivo no contenía registros válidos para cargar. Favor de verificar.",
                });
            } else {
                this.$swal({
                    type: "success",
                    title: "¡Operación Exitosa!",
                    text: "El archivo se cargó correctamente.",
                    footer: '',
                });
            }
            this.modalUpload = false;

        },
        submitFile() {
            /** ZIP o XML de Facturas */
            if (this.file != "") {
                this.$root.$dialogLoader.show('Espere un momento por favor..');
                this.cargarEmisores();
                //let formData = new FormData();
                var registrosExcel = [];
                /*formData.append('file', this.file);    
                formData.append('tipo', 'mercancia');
                formData.append('referencia', this.$local_storage.get("referencia"));
                formData.append('user_updated', this.$local_storage.get("email"));
                formData.append('usuario', this.$local_storage.get("id_usuario"));*/
                let formData = {
                    file: this.file,
                    filename: this.fileName,
                    tipo: 'incrementable',
                    referencia: this.$local_storage.get("referencia"),
                    user_updated: this.$local_storage.get("email"),
                    usuario: this.$local_storage.get("id_usuario"),
                };

                axios.post(this.$hostname + 'leexml/', formData)
                    .then((res) => {
                        if (typeof res.data !== 'undefined') {
                            //console.log(res.data);

                            /*var results = res.data;  
                var erroresCont = 0;
                var erroresText = '';
                var errorTmp = '';
                results.forEach(element => {                  
                  if (!this.verificaEmisor(element.tax_id, 'verifica'))  {
                      erroresCont++;                      
                      errorTmp = '<br/>'+ "- El emisor '"+ element.emisor +"' no existe en el catálogo de emisores/destinatarios con el Tax ID: '"+element.tax_id+"'";
                      if (erroresText.indexOf(errorTmp) == -1) 
                        erroresText += errorTmp;
                  } else if (this.verificaFactura(element.numero, element.tax_id)){
                      erroresCont++;                      
                      errorTmp = '<br/>'+ "- La factura número '"+ element.numero +"' del emisor '"+element.tax_id+"' ya ha sido registrada";
                      if (erroresText.indexOf(errorTmp) == -1) 
                        erroresText += errorTmp;
                  } else{
                      element.tax_id = this.verificaEmisor(element.tax_id, 'obtener')
                      element.fecha = this.parseDate(element.fecha);
                      var emisores = this.emisores.filter(function(emi){
                          return emi.rfc == element.tax_id;
                      });
                      element.emisor = emisores[0].metadato;
                      element.pais_vendedor = emisores[0].pais.clave_m3 != null? emisores[0].pais.clave_m3 : emisores[0].pais.nombre;
                      
                      this.detalles.push(element); 
                      registrosExcel.push(element);                        
                  }
              });  
                            
              if (erroresCont > 0) {
                  this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: erroresText,
                    });                                                                              
              } else if (registrosExcel.length == 0) {            
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "El archivo no contenía registros válidos para cargar. Favor de verificar.",                
                    });                
              } else {
                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "El archivo se cargó correctamente.",
                        footer: '',
                    });  
              }*/
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                                footer: '',
                            });
                            this.modal = false;
                            this.cargar();

                        }

                    })
                    .catch((error) => {
                        var msg = ''
                        var mostrar = true;
                        if (error.response != null) {
                            if (error.response.data.mensaje != null)
                                msg = error.response.data.mensaje[0];
                            if (error.response.data.message != null) { //Si entra aqui significa que regreso un TimeOut de Amazon Api, recibirá notificacion cuando temrine                
                                mostrar = false;
                                this.$swal({
                                    type: "success",
                                    title: "¡Operación Exitosa!",
                                    text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                                    footer: '',
                                });
                                msg = error.response.data.message;
                                this.cargar();
                            }
                        }
                        if (mostrar) {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al cargar el archivo",
                                footer: msg,
                            });
                            console.log(error);
                        }

                    }).then(() => {
                        this.modal = false;
                        this.$root.$dialogLoader.hide();
                        this.reset();
                    });
            }

        },
        handleFileUpload() {
            this.file = this.$refs.file.files[0];
            if (this.file.size > 1000 * 1000 * 3) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "El archivo no debe ser mayor a 3MB.",
                });
                this.file = "";
                this.fileName = "";
                this.$refs.file.value = "";
                this.showfile = false;
            } else {
                const fr = new FileReader();
                fr.readAsDataURL(this.$refs.file.files[0]);
                fr.addEventListener('load', () => {
                    this.file = fr.result; // archivo en base64
                });
                this.fileName = this.file.name;
                this.showfile = true;
            }
        },

        addFileFactura: function (numero_factura, rfc, archivo, secuencia) {
            this.modalFactura = true;
            this.modalFacturaNumero = numero_factura;
            this.modalFacturaArchivo = archivo;
            this.modalFacturaRfc = rfc;
            this.modalFacturaSecuencia = secuencia;
        },

        handleFileUploadFactura() {
            this.fileFactura = this.$refs.fileFactura.files[0];
            this.sizeFactura = this.fileFactura.size;
            var nombre = this.fileFactura.name.split(".");
            if (this.modalFacturaNumero != nombre[0]) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "El nombre del archivo no coincide con el número de factura. Favor de verificar.",
                });
                this.fileFactura = "";
                this.fileFacturaName = "";
                this.reset();
            } else if (this.fileFactura.size > 1000 * 1000 * 3) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "El archivo no debe ser mayor a 3MB.",
                });
                this.fileFactura = "";
                this.fileFacturaName = "";
                this.reset();
            } else {
                const fr = new FileReader();
                fr.readAsDataURL(this.$refs.fileFactura.files[0]);
                fr.addEventListener('load', () => {
                    this.fileFactura = fr.result; // archivo en base64
                });
                this.fileFacturaName = this.fileFactura.name;
                this.showfile = true;
            }
        },

        submitFileFactura: async function (rfc_emisor, secuencia) {
            /** Documento de Factura */
            if (this.fileFacturaName != "") {
                var nombreArchivo = "170_"+ this.fileFacturaName.replace(/.pdf/ig,".pdf");
                var referencia = this.$local_storage.get('referencia').split("-");
                // 170 es porque por default se considera factura
                var keyBucket = this.$local_storage.get("rfc") + "/traficos/" +
                    referencia[1] + "/adjuntos/170/" + nombreArchivo;
                this.$root.$dialogLoader.show('Espere un momento por favor..');
                /*let formData = new FormData();          
                formData.append('file', this.fileFactura);                 
                formData.append('key', keyBucket);*/

                let formData = {
                    file: this.fileFactura,
                    key: keyBucket,
                    usuario: this.$local_storage.get("id_usuario"),
                };

                axios.post(this.$hostname + 'uploads3/', formData)
                    .then((res) => {
                        if (typeof res.data !== 'undefined') {
                            var thisC = this;
                            this.detalles.forEach(function (el) {
                                if (el.tax_id == rfc_emisor && el.numero == thisC.modalFacturaNumero && el.secuencia == secuencia) {
                                    thisC.formUpdated = true;
                                    el.archivo = keyBucket;
                                }

                            });

                            this.actualizarAdjuntosTrafico(nombreArchivo);

                            this.modalFactura = false;
                            //Despues de subir el archivo a S3, guardamos el detalle para asegurar que se guarde el campo archivo
                            return new Promise((resolve, reject) => {
                                this.guardar(resolve);
                            });

                        }
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al cargar el documento de factura",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.modalFactura = false;
                        this.$root.$dialogLoader.hide();
                        this.reset();
                    });
            }

        },

        actualizarAdjuntosTrafico: function(fileArchivo){               
            var adjuntos = [{"filename":fileArchivo.replace(/.pdf/ig,""),
                        "ext":"pdf",
                        "size":this.sizeFactura,
                        "email_usuario": this.$local_storage.get("email"),
                        "nombre_usuario":this.$local_storage.get("nombre_usuario"),
                        "iniciales":"",
                        "perfil_usuario":"",
                        "tipo_usuario": this.$local_storage.get("tipo_usuario"),
                        "fuente":"sistema"}];
            var datos = {
                "referencia": this.$local_storage.get('referencia'),
                "adjuntos": adjuntos
            }
            axios.post(this.$hostname + 'traficos/set_adjuntos/', datos)
                .then((res) => {
                    
                })
                .catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al guardar el registro adjunto en el tráfico. Favor de comunicarse con soporte.",
                        footer: '',
                    });
                    console.log(error);
                });
        },

        downloadFileFactura: async function (archivo_key) {
            this.loadingDownload = true;
            var datos = {
                id: archivo_key
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        //a.download = name[name.length - 1];
                        a.click();
                        a.parentNode.removeChild(a);

                        this.modalFactura = false;
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar en S3",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el documento de factura";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.loadingDownload = false;
                    this.reset();
                });
        },

        deleteFileFactura: async function (archivo_key, secuencia) {
            this.loadingDelete = true;
            var datos = {
                key: archivo_key
            }
            axios.post(this.$hostname + 's3/delete/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var thisC = this;
                        this.detalles.forEach(function (el) {
                            if (el.tax_id == thisC.modalFacturaRfc && el.numero == thisC.modalFacturaNumero &&
                                el.secuencia == secuencia) {
                                thisC.formUpdated = true;
                                el.archivo = '';
                            }

                        });
                        this.modalFactura = false;
                        this.deleteAdjunto(archivo_key);
                        //Despues de eliminar el archivo de S3, guardamos el detalle para asegurar que se guarde el campo archivo
                        return new Promise((resolve, reject) => {
                            this.guardar(resolve);
                        });
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar en S3",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al intentar eliminar el documento",
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.loadingDelete = false;
                    this.reset();
                });
        },

        deleteAdjunto: function(archivokey){
            var datos = {
                key: archivokey
            }
            axios.post(this.$hostname + 'traficos/delete_adjunto/', datos)
                .then((res) => {
                    
                })
                .catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al eliminar el registro adjunto del tráfico. Favor de comunicarse con soporte.",
                        footer: '',
                    });
                    console.log(error);
                });
        },

        formChanged: function (newV, oldV) {
            this.formUpdated = true;
            var sumtotal = 0;
            for (var k in this.detalles) {
                var sum = 0;
                var tieneConcepto = false;
                var detalle = this.detalles[k];
                if (detalle != undefined) {
                    detalle['conceptos'].forEach(function (e) {
                        tieneConcepto = true;
                        if (e.valor_dolares != undefined && e.valor_dolares > 0)
                            sum += parseFloat(e.valor_dolares);
                    });
                    if (tieneConcepto)
                        this.detalles[k].importe = sum;
                    else
                        sum = (this.detalles[k].importe != undefined && this.detalles[k].importe.toString().trim() != '') ? parseFloat(this.detalles[k].importe) : 0;
                }
                sumtotal += sum;
            }
            this.total_usd = sumtotal;
        },
        reset() {
            const input = this.$refs.file;
            input.type = 'text'
            input.type = 'file'

            const inputFactura = this.$refs.fileFactura;
            inputFactura.type = 'text'
            inputFactura.type = 'file'

            this.showfile = false;
        },
        urltoFile: function (url, filename, mimeType) {
            return (fetch(url)
                .then(function (res) {
                    return res.arrayBuffer();
                })
                .then(function (buf) {
                    return new File([buf], filename, {
                        type: mimeType
                    });
                })
            );
        },
        enviarCorreos: function () {
            var referencia = this.$local_storage.get('referencia');
            var rfc = this.$local_storage.get('rfc');
            this.$root.$dialogLoader.show('Espere un momento por favor..');
            var contactos = [];
            var datos = {
                rfc: rfc,
                referencia: referencia,
            };
            axios.post(this.URL + 'obtener/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        res.data.alertas.forEach(function (el) {
                            contactos.push(el.email);
                        })
                        if (contactos.length > 0) {
                            this.$swal({
                                type: "info",
                                title: "Enviar Notificaciones",
                                text: "¿Desea enviar correo de notificación a los contactos registrados en este tráfico?",
                                showCancelButton: true,
                                cancelButtonColor: "#d33",
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: "Si",
                                cancelButtonText: "No"
                            }).then(result => {
                                if (result.value) {
                                    //Generamos PDF del tráfico
                                    for (let key in res.data) {
                                        this.modelPdf[key] = res.data[key];
                                    }
                                    var opt = {
                                        margin: [1, 0.5, 1, 0.5], //top, left, bottom, right
                                        filename: referencia + ".pdf",
                                        image: {
                                            type: "jpeg",
                                            quality: 0.5
                                        },
                                        html2canvas: {
                                            scale: 2
                                        },
                                        pagebreak: {
                                            mode: ["avoid-all", "css", "legacy"]
                                        },
                                        jsPDF: {
                                            unit: "in",
                                            format: "letter",
                                            orientation: "landscape"
                                        }
                                    };
                                    var thisC = this;
                                    var doc = html2pdf()
                                        .set(opt)
                                        .from(document.getElementById("pdf"))
                                        .toPdf().output('datauristring')
                                        .then(pdf => {
                                            //console.log(pdf);                              
                                            //console.log(file);
                                            thisC.show_loading = true;
                                            let datos = {
                                                file: pdf,
                                                file_name: referencia + ".pdf",
                                                sistema: thisC.$sistema,
                                                emails: contactos,
                                                asunto: "Nuevo Tráfico: " + referencia,
                                                mensaje: "Hacemos de su conocimiento que se generó un nuevo tráfico con el número de referencia: " + referencia,
                                            };
                                            /*datos.append('file', file);
                                            datos.append('sistema', thisC.$sistema);
                                            datos.append('emails', contactos);
                                            datos.append('asunto', "Nuevo Tráfico: "+referencia);
                                            datos.append('mensaje', "Hacemos de su conocimiento que se generó un nuevo tráfico con el número de referencia: "+referencia);*/
                                            axios.post(thisC.$hostname + 'correos/enviar/', datos)
                                                .then((res) => {
                                                    if (typeof res.data !== 'undefined') {
                                                        thisC.showMensajeExito(referencia,
                                                            "Las notificaciones se enviaron correctamente. El registro de tráfico se guardó con la referencia:\n" + referencia
                                                        );
                                                        return true;
                                                    }
                                                })
                                                .catch((error) => {
                                                    var errorMsg = "";
                                                    console.log(error);
                                                    if (typeof error.response.data != undefined) {
                                                        for (var k in error.response.data) {
                                                            for (var j in error.response.data[k])
                                                                errorMsg += k + ": " + error.response.data[k][j] + "<br/>"
                                                        }
                                                    }
                                                    thisC.$swal({
                                                        type: "error",
                                                        title: "¡Operación no Permitida!",
                                                        text: "Ocurrió un error al enviar los correos de notificación",
                                                        footer: errorMsg,
                                                    });
                                                    return false;
                                                }).then(() => {
                                                    thisC.show_loading = false;
                                                });

                                        }).catch(error => {
                                            console.log(error);
                                        });

                                } else {
                                    this.showMensajeExito(referencia, "");
                                    return true;
                                }
                            });

                        } else {
                            this.showMensajeExito(referencia, "");
                            return true;
                        }
                    }
                })
                .catch((err) => {
                    this.$swal({
                        position: "center",
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Error al obtener los contactos para enviar correos de notificación"
                        //showConfirmButton: false,
                    });
                    console.log(err.response);
                    return false;
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        showMensajeExito(referencia, mensaje = "") {
            var msg = "El registro de tráfico se guardó correctamente con la referencia:\n" + referencia;
            if (mensaje != "")
                msg = mensaje;

            this.$router.push('/trafico_index', () => {
                this.$swal({
                    type: "success",
                    title: "¡Operación Exitosa!",
                    text: msg,
                });

            });
        },

    }, //methods

    filters: {
        moneda: function (value) {
            if (value) {
                var parts = value.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return parts.join(".");
            }
        }
    },

    created: function () {
        this.URL = this.$hostname + 'traficos/';
        this.cargarEmisores();
        this.$root.$dialogLoader.show('Espere un momento por favor..');
        this.cargar();
        this.formUpdated = false;
        this.$watch('detalles', this.formChanged, {
            deep: true
        });
    },
    beforeDestroy: function () {
        this.detalles = [];
    },

}
</script>

<style scoped>
#trafico-detalle-facturas {
    font-size: small;
    /* | x-small | small  */
}

#trafico-detalle-facturas>>>.v-input {
    /*Texto dentro del input*/
    font-size: small !important;
}

#trafico-detalle-facturas>>>.v-label {
    /*Etiqueta o placeholder del input*/
    font-size: small !important;
    margin-top: 5px !important;
}

#trafico-detalle-facturas>>>.v-messages__message {
    /*Mensaje de Error*/
    font-size: x-small !important;
    margin-top: -0px !important;
}

#trafico-detalle-facturas>>>.form-group {
    /*Celda de cada v-input */
    margin-top: 0px !important;
    margin-bottom: -5px !important;
    margin-right: -10px !important;
    margin-left: -10px !important;
}

#detalle_conceptos {
    /*Div de los cocneptos de una factura */
    margin-left: 25px !important;
}

#trafico-detalle-facturas>>>#separaFactura {
    /*Separador de cada factura */
    background-color: black !important;
    height: 2px;
}

#trafico-detalle-facturas>>>#separaConcepto {
    /*Separador de cada Concepto */
    background-color: blue !important;
    margin-bottom: -5px !important;
}
</style>
